import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { t } from "@i18n";

function BulkUpdateRolesModal({ headerText, closeModal, modalState, confirmClick, confirmEnabled, modalContent }: any) {
  return (
    <ModalStateDialogComponent
      allowModalPadding={false}
      width="60%"
      onCancel={() => closeModal()}
      headerTitle={headerText}
      modelContent={modalContent()}
      footerContent={
        <div className="flex gap-[1.375rem] px-10 pb-7 pt-4">
          <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={confirmClick} disabled={!confirmEnabled}>
            {t("Confirm")}
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
            {t("Discard")}
          </ButtonComponent>
        </div>
      }
      isVisible={modalState}
    />
  );
}

export default BulkUpdateRolesModal;
